import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { useData } from '../../contexts/DataContext';
import { useLanguage } from '../../contexts/LanguageContext';

export const BankAccountsPage: React.FC = () => {
  const { theme } = useTheme();
  const { t } = useLanguage();
  const { bankAccounts } = useData();

  return (
    <div className={`content-section ${theme.isDark ? 'dark' : 'light'}`}>
      <h2>{t('references.bankAccounts')}</h2>
      <p>Страница банковских счетов в разработке...</p>
      <p>Всего счетов: {bankAccounts.items.length}</p>
    </div>
  );
};
